import { Link, useParams } from "react-router-dom";
import methods from "../../../services/utility";
import { useState } from "react";
import Preloading from "../../../components/basics/Preloading";
import back from "../../../assets/images/icons/arrow-right2.svg";

const BaseinfoHome = () => {
  const { branchId } = useParams();
  const [loading, setLoading] = useState(false);

  const renderBaseinfoHome = () => {
    return (
      <>
        {loading && <Preloading></Preloading>}
        {
          <>
            <div className="d-none d-lg-block">
              <Link
                to={`/sale/${branchId}`}
                className="text-start mb-3 link back-link"
              >
                <span>
                  <img src={back} className="" alt="return" />
                </span>
                بازگشت
              </Link>
            </div>
            <div className="d-lg-none d-flex justify-content-between align-items-baseline saleheader">
              <Link to={`/sale/${branchId}`} className="link back-link">
                <span>
                  <img src={back} className="" alt="return" />
                </span>
                طبقات کالا
              </Link>
              <p className="date">{methods.currentDate()}</p>
            </div>
            <div className="d-lg-none d-flex justify-content-between align-items-baseline saleheader">
              <div>اطلاعات عمومی</div>
              <p className="date">{methods.currentDate()}</p>
            </div>
            <div className="saleheader d-none d-lg-block">
              <p>اطلاعات عمومی</p>
            </div>
            <div className="salemain bg-light">
              <div className="row g-3">
                {/* <div className="col-md-6 col-lg-3 text-center">
									<Link to='/dashboard' className="link">
										<div className='p-4 rounded-4 shadow bg-white card'>
											داشبورد
										</div>
									</Link>
								</div> */}
                <div className="col-md-6 col-lg-4 text-center">
                  <Link
                    to={`/baseinfo/${branchId}/productcategory`}
                    className="link"
                  >
                    <div className="p-4 rounded-4 shadow bg-white card">
                      طبقات کالا
                    </div>
                  </Link>
                </div>
                <div className="col-md-6 col-lg-4 text-center">
                  <Link
                    to={`/baseinfo/${branchId}/unitmeasurements`}
                    className="link"
                  >
                    <div className="p-4 rounded-4 shadow bg-white card">
                      واحدهای سنجش
                    </div>
                  </Link>
                </div>
                <div className="col-md-6 col-lg-4 rounded-4 text-center">
                  <Link to={`/baseinfo/${branchId}/product`} className="link">
                    <div className="p-4 rounded-4 shadow bg-white card">
                      کالاها
                    </div>
                  </Link>
                </div>
              </div>
            </div>
          </>
        }
      </>
    );
  };

  return <>{renderBaseinfoHome()}</>;
};

export default BaseinfoHome;
